import { useNavigate } from "react-router-dom";
import { LOGIN_PATH } from "Routes/paths";
import LangButton from "components/languageButton/LangButton";
import UserInfo from "./UserInfo";
import Cart from "./Cart";
import { useTranslation } from "react-i18next";
import { RootState } from "redux/rootReducer";
import { useSelector } from "react-redux";

const Settings = () => {
  const { t, i18n } = useTranslation();

  const navigate = useNavigate();
  const { loginData } = useSelector((state: RootState) => state.loginReducer);

  return (
    <>
      <div className="lg:w-[25%] flex items-center justify-end gap-6 lg:gap-6">
        {/* cart icon  */}
        <Cart />

        {/* language section  */}
        <div className="hidden lg:block">
          <LangButton />
        </div>

        {loginData ? (
          <UserInfo data={loginData} />
        ) : (
          <>
            {/* login button  */}
            <div>
              <button
                className={` h-[32px] bg-first_color text-white text-[13px] ${
                  i18n.language === "en"
                    ? "font-Poppins w-[80px]"
                    : "font-Almarai w-[100px]"
                } font-[600] rounded-[10px] hover:bg-[#614629] duration-300`}
                onClick={() => navigate(LOGIN_PATH)}
              >
                {t("login")}
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default Settings;
